import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Compass, CalendarDays, Bell, User } from "lucide-react";
import { CountBadge } from "@/components/CountBadge";
import { Avatar } from "@/components/Avatar";

export const LAST_CITY_KEY = "vv_last_city";

export function BottomTabs({ user, unread }) {
  const { pathname, search } = useLocation();
  useEffect(() => {
    document.body.classList.add("has-tabs");
    return () => document.body.classList.remove("has-tabs");
  }, []);
  const lastCity = localStorage.getItem(LAST_CITY_KEY);
  const tabs = [
    ["explore", lastCity ? `/explore?city=${encodeURIComponent(lastCity)}` : "/explore", "/explore", Compass, "Explore"],
    ["trip", "/trip", "/trip", CalendarDays, "My Trip"],
    ["alerts", "/notifications", "/notifications", Bell, "Alerts", unread.personal + unread.business],
    ["account", "/account", "/account", null, "Account"],
  ];
  return (
    <nav data-testid="bottom-tabs" className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-[#0B0F19]/90 backdrop-blur-xl border-t border-[#26334D] pb-[env(safe-area-inset-bottom)]">
      <div className="grid grid-cols-4">
        {tabs.map(([id, to, base, Icon, label, n]) => {
          const active = pathname.startsWith(base);
          return (
            <Link key={id} to={active && id === "explore" ? `/explore${search}` : to} data-testid={`bottom-tab-${id}`} aria-current={active ? "page" : undefined}
              className={`relative flex flex-col items-center justify-center gap-1 h-16 text-[11px] font-semibold transition-colors active:scale-95 ${active ? "text-[#FF3B6B]" : "text-slate-400"}`}>
              <span className={`absolute top-0 h-0.5 w-10 rounded-full bg-[#FF3B6B] transition-opacity ${active ? "opacity-100" : "opacity-0"}`} />
              <span className="relative">
                {Icon ? <Icon className="h-6 w-6" /> : <Avatar url={user.avatar_url} name={user.name} size="h-6 w-6" text="text-[10px] text-white" className={active ? "ring-2 ring-[#FF3B6B]" : ""} testid="bottom-tab-avatar" />}
                {n > 0 && <span className="absolute -top-1.5 -right-2.5"><CountBadge n={n} testid={`bottom-tab-${id}-badge`} /></span>}
              </span>
              {label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
